import React, { useState, useEffect } from 'react';
import useValidationCode, { formatTime } from '../../components/useValidationCode';
import { alphabets, nombres } from '../../components/enigmes/e_alphab_2.js';
import '../../css/Fin.css';

function Fin2() {
    const {
        inputValue, showVideo, errorMessage, attemptHistory,
        isBlocked, remainingTime, pending,
        addLetter: handleClick, reset: handleReset, validate: handleValidation,
    } = useValidationCode(2);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        document.title = 'Fin2';
    }, []);

    useEffect(() => {
        // Detect if the screen width is less than 770px
        const handleResize = () => {
            if (window.innerWidth < 770) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        // Add resize event listener
        window.addEventListener('resize', handleResize);

        // Call once to set initial state
        handleResize();

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const placeholderText = isBlocked
        ? `Vous êtes bloqué pendant encore ${formatTime(remainingTime)}`
        : 'Cliquez sur les lettres pour les ajouter';


    return (
        <div className='fin'>
            <div className="espaceHaut"></div>

            {isMobile && (
                <div style={{ textAlign: 'center', marginTop: '20px', color: 'white' }}>
                    <p>Veuillez mettre votre téléphone en mode paysage pour une meilleure expérience.</p>
                </div>
            )}

            <div className="alphabet-container">
                <div className='text-center'>
                    <img
                        key='titre'
                        src={`${process.env.PUBLIC_URL}/img/alphac/A1.jpg`}
                        alt='titre alphac'
                        style={{
                            margin: '2px',
                            padding: 0,
                            height: '100px',
                        }}
                    />
                </div>
                {Object.entries(alphabets).reduce((rows, [letter, image], index) => {
                    const rowIndex = Math.floor(index / 17); // Divise en groupes de 17 images
                    if (!rows[rowIndex]) {
                        rows[rowIndex] = []; // Initialise une nouvelle ligne si nécessaire
                    }
                    rows[rowIndex].push(
                        <img
                            key={letter}
                            src={`${process.env.PUBLIC_URL}/img/alphac/${image}`}
                            alt={letter}
                            onClick={() => handleClick(letter)}
                            style={{
                                cursor: 'pointer',
                                margin: '2px',
                                padding: 0,
                                height: '80px',
                            }}
                        />
                    );
                    return rows;
                }, []).map((row, rowIndex) => (
                    <div
                        key={rowIndex}
                        style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', padding: 0, justifyContent: 'center' }}
                    >
                        {row}
                    </div>
                ))}

                {Object.entries(nombres).reduce((rows, [number, image], index) => {
                    const rowIndex = Math.floor(index / 10);
                    if (!rows[rowIndex]) {
                        rows[rowIndex] = []; // Initialise une nouvelle ligne si nécessaire
                    }
                    rows[rowIndex].push(
                        <img
                            key={number}
                            src={`${process.env.PUBLIC_URL}/img/alphac/${image}`}
                            alt={number}
                            onClick={() => handleClick(number)}
                            style={{
                                cursor: 'pointer',
                                margin: '2px',
                                padding: 0,
                                height: '80px',
                            }}
                        />
                    );
                    return rows;
                }, []).map((row, rowIndex) => (
                    <div
                        key={rowIndex}
                        style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', padding: 0, justifyContent: 'center' }}
                    >
                        {row}
                    </div>
                ))}
            </div>

            {errorMessage && <p style={{ color: isBlocked ? 'red' : 'white' }}>{errorMessage}</p>}

            <ul>
                {attemptHistory.map((attempt, index) => (
                    <li key={index} style={{ color: 'gray' }}>
                        {attempt}
                    </li>
                ))}
            </ul>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', justifyContent: 'center' }}>
                <input
                    type="text"
                    value={inputValue}
                    readOnly
                    placeholder={placeholderText}
                    style={{ marginTop: '10px', padding: '5px', width: '400px' }}
                />
                <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                    <button
                        onClick={handleValidation}
                        style={{ margin: '10px 0px 15px 10px', padding: '5px 15px' }}
                        disabled={isBlocked || pending || !inputValue}
                        className="btn btnBeige"
                    >
                        validation
                    </button>
                    <button
                        onClick={handleReset}
                        style={{ marginTop: '10px', padding: '5px 15px' }}
                        disabled={isBlocked}
                        className="btn"
                    >
                        reset
                    </button>
                </div>
            </div>

            {showVideo && (
                <iframe src="https://player.vimeo.com/video/1038021211"
                    width="640"
                    height="360"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen>
                </iframe>
            )}
        </div>
    );
}

export default Fin2;
